import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { Prefrence } from 'src/app/module/pierhippak/model/interfaces';
import { PdfGeneratorServiceService } from 'src/app/shared/pdf-generator-service.service';

@Component({
  selector: 'app-pierhippak',
  templateUrl: './pierhippak.component.html',
  styleUrls: ['./pierhippak.component.css'],
})
export class PIERHIPPAKComponent implements OnInit {
  preference: Prefrence | null = null;
  email: string | undefined = '';
  tollfreeNo: string | undefined | null = '';
  faxNo: string | undefined | null = '';
  errorMessageIntialData: string = '';
  mailingAddress: string = '';
  dropingAddress: string ='';
  emailTo: string = '';
  logo: any;
  applicationPdf: any;

  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private pdfService: PdfGeneratorServiceService
  ) {}

  ngOnInit(): void {
    this.logo = 'app/module/pierhippak/assets/img/AK_Logo.png';
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;
        this.faxNo = ValidationService.formatPhoneNumber(
          this.preference.preferenceValues?.['FAX_NUM']
        );
        this.tollfreeNo = ValidationService.formatPhoneNumber(
          this.preference.preferenceValues?.['TOLL_FREE_NUM']
        );
        this.email = this.preference.preferenceValues?.['EMAIL_ID'];
        this.emailTo = 'mailto:' + this.email;
        this.mailingAddress =
          '' +
          this.preference.preferenceValues?.['MAIL_OFFICE'] +
          ', ' +
          this.preference.preferenceValues?.['MAIL_ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['MAIL_ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['MAIL_CITY'] +
          ', ' +
          this.preference.preferenceValues?.['MAIL_STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['MAIL_ZIPCD'];
        this.dropingAddress =
        '' +
          this.preference.preferenceValues?.['DROPOFF_OFFICE'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_CITY'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['DROPOFF_ZIPCD'];
          this.applicationPdf = this.preference.paperApplication;
      },
      error: (err: HttpErrorResponse) => {
        this.logger.logMsg(err.error);
        const msg = 'Unable to get the Preference details: ' + err.message;
        this.errorMessageIntialData = msg;
      },
    });
  }

   openPaperApplication(){
    this.pdfService.generatePdf(this.applicationPdf, 'PaperApplication.pdf');
  }
}
